// Per-event 3-way payment option toggles shared by the Tournament and
// Open Play creation wizards. At least one option must remain selected.
const OPTS = [
  { key: 'full', label: 'Pay 100%', desc: 'Full amount upfront' },
  { key: 'deposit50', label: '50% Deposit', desc: 'Half now, half at venue' },
  { key: 'counter', label: 'Pay at Venue', desc: 'Reserve now, pay on-site' },
];

export const PayOptionsPicker = ({ value = [], onChange, testidPrefix = 'pay-opt' }) => {
  const toggle = (k) => {
    const next = value.includes(k) ? value.filter(x => x !== k) : [...value, k];
    if (next.length === 0) return; // must keep at least one option
    onChange(next);
  };
  return (
    <div className="grid grid-cols-3 gap-2">
      {OPTS.map(o => {
        const active = value.includes(o.key);
        return (
          <button key={o.key} type="button" data-testid={`${testidPrefix}-${o.key}`} onClick={() => toggle(o.key)}
            className="p-2.5 rounded-lg text-left transition-all"
            style={{ background: active ? 'rgba(230,57,70,0.10)' : '#0F0F0F', border: `1px solid ${active ? '#E63946' : '#2A2A2A'}` }}>
            <p className="text-xs font-bold" style={{ color: active ? '#fff' : '#737373' }}>{active ? '✓ ' : ''}{o.label}</p>
            <p className="text-[10px] mt-0.5" style={{ color: '#555' }}>{o.desc}</p>
          </button>
        );
      })}
    </div>
  );
};

export default PayOptionsPicker;
